// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ed3810f9","732":"d14b0a20","977":"58670ecd"}[chunkId] + ".chunk.js";
};